import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { TranslatePipe } from '@ngx-translate/core';
import { IconComponent } from '@swissfex/sfx-commons';
import { Observable } from 'rxjs';

import { TranslateOutletPipe } from '../../common-utils/pipes/translate-outlet.pipe';
import { TranslateRoutePipe } from '../../common-utils/pipes/translate-route.pipe';
import { MAIN_ROUTES, OUTLET_NAMES, PATH_NAMES_PER_OUTLETS } from '../../constants';
import { NewsService } from '../../projects/services/news.service';

@Component({
    selector: 'app-news-bar',
    templateUrl: './news-bar.component.html',
    styleUrls: ['./news-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AsyncPipe, TranslatePipe, IconComponent, RouterLink, TranslateOutletPipe, TranslateRoutePipe]
})
export class NewsBarComponent {
    protected readonly activatedRoute = inject(ActivatedRoute);
    private readonly newsSvc = inject(NewsService);

    public newsCount = input.required<number>();

    public readonly hasUnreadNews$: Observable<boolean>;
    public readonly xMarkIcon = faXmark;
    public readonly NEWS_OUTLET = {
        [OUTLET_NAMES.NEWS_MODAL_OUTLET]: PATH_NAMES_PER_OUTLETS[OUTLET_NAMES.NEWS_MODAL_OUTLET]
    };
    public readonly PROJECTS_ROUTE = MAIN_ROUTES.PROJECTS;

    constructor() {
        this.hasUnreadNews$ = this.newsSvc.hasUnreadNews$;
    }

    public hideNews = () => {
        this.newsSvc.updateUnreadNewsStatus(false);
    };
}
